var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mounted)?_c('div',{attrs:{"id":"app"}},[(!_vm.isLoginRoute)?_c('navigation',{attrs:{"organisation":_vm.organisation}}):_vm._e(),_c('toaster-messages'),_c('router-view')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }